import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent } from '@app/components/dialog/dialog.component';
import { ButtonComponent } from '@app/components/button/button.component';
import { SecondaryButton } from '@components/button/secondary-button/secondary-button';
import { UploadedGeoImageService } from '../services/uploaded-geo-image.service';
import { UploadedGeoImageListItem } from '../services/uploaded-geo-image.models';

/** Asks for confirmation before an uploaded geo-image is deleted (FR-014). Deletion is a soft delete: the file stays in storage. */
@Component({
  selector: 'app-geo-image-delete-modal',
  standalone: true,
  templateUrl: './geo-image-delete-modal.component.html',
  styleUrls: ['./geo-image-delete-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, DialogComponent, ButtonComponent, SecondaryButton]
})
export class GeoImageDeleteModalComponent {
  @Input() visible = false;
  @Input() item: UploadedGeoImageListItem | null = null;
  @Input() loading = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  constructor(private readonly api: UploadedGeoImageService) {}

  get previewUrl(): string | null {
    return this.item ? this.api.getThumbnailUrl(this.item, 240, 240) : null;
  }

  handleCancel(): void {
    this.visibleChange.emit(false);
    this.cancel.emit();
  }

  handleConfirm(): void {
    if (!this.loading) {
      this.confirm.emit();
    }
  }
}
